import { render, staticRenderFns } from "./TouchPoint.vue?vue&type=template&id=4e17d3f2&scoped=true"
import script from "./TouchPoint.vue?vue&type=script&lang=js"
export * from "./TouchPoint.vue?vue&type=script&lang=js"
import style0 from "./TouchPoint.vue?vue&type=style&index=0&id=4e17d3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e17d3f2",
  null
  
)

export default component.exports